<template>
  <div>
      <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
  </div>
</template>

<script>
import { AuthorizationHeader } from '@/common/jwt.service'
import { ApiUrl } from '@/common/api.service'
import columns from './RequestsDatatable/columns'

export default {
    data() {
        return {
            query: {},
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "dedicated_requests_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('dedicated/admin/get-requests'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
            }
        },
    },
}
</script>
